import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { supabase } from '../../config/supabase';

interface StockMovement {
  id: string;
  product_id: string;
  type: 'in' | 'out';
  quantity: number;
  description: string;
  created_at: string;
}

interface StockMovementsState {
  items: StockMovement[];
  loading: boolean;
  error: string | null;
}

const initialState: StockMovementsState = {
  items: [],
  loading: false,
  error: null,
};

export const getStockMovements = createAsyncThunk(
  'stockMovements/getStockMovements',
  async () => {
    const { data, error } = await supabase
      .from('stock_movements')
      .select('*');
    
    if (error) throw error;
    return data;
  }
);

const stockMovementsSlice = createSlice({
  name: 'stockMovements',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStockMovements.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStockMovements.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(getStockMovements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Erro ao carregar movimentações de estoque';
      });
  },
});

export default stockMovementsSlice.reducer; 